module.exports = __webpack_public_path__ + "img/06b_Share_Gigya01.7e58987d.jpg";